module.exports = __webpack_public_path__ + "assets/img/like.84ea5c8b.svg";